import { render } from "./DetalhesVoucher.vue?vue&type=template&id=2665c6b4&scoped=true"
import script from "./DetalhesVoucher.vue?vue&type=script&lang=js"
export * from "./DetalhesVoucher.vue?vue&type=script&lang=js"

import "./DetalhesVoucher.vue?vue&type=style&index=0&id=2665c6b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2665c6b4"]])

export default __exports__